import React from 'react';
import Icon from '../../../components/AppIcon';

const GalleryFilters = ({ filters, onChange, sites, workers, loading }) => {
  const handleChange = (key, value) => onChange?.({ ...filters, [key]: value });

  return (
    <div className="bg-card border border-border rounded-2xl p-4 shadow-elevation-1">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="SlidersHorizontal" size={16} className="text-muted-foreground" />
        <h3 className="text-sm font-semibold text-foreground">Filter Photos</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {/* Site filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1.5">Site</label>
          <select
            value={filters?.siteId || 'all'}
            onChange={e => handleChange('siteId', e?.target?.value)}
            disabled={loading}
            className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent/30 text-foreground"
          >
            <option value="all">All Sites</option>
            {sites?.map(s => <option key={s?.id} value={s?.id}>{s?.site_name}</option>)}
          </select>
        </div>
        {/* Worker filter */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1.5">Worker</label>
          <select
            value={filters?.uploadedBy || 'all'}
            onChange={e => handleChange('uploadedBy', e?.target?.value)}
            disabled={loading}
            className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent/30 text-foreground"
          >
            <option value="all">All Workers</option>
            {workers?.map(w => <option key={w?.id} value={w?.id}>{w?.full_name}</option>)}
          </select>
        </div>
        {/* Date from */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1.5">From Date</label>
          <input
            type="date"
            value={filters?.dateFrom || ''}
            onChange={e => handleChange('dateFrom', e?.target?.value)}
            className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent/30 text-foreground"
          />
        </div>
        {/* Date to */}
        <div>
          <label className="block text-xs font-medium text-muted-foreground mb-1.5">To Date</label>
          <input
            type="date"
            value={filters?.dateTo || ''}
            onChange={e => handleChange('dateTo', e?.target?.value)}
            className="w-full px-3 py-2 text-sm bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-accent/30 text-foreground"
          />
        </div>
      </div>
      {/* Active filter chips */}
      {(filters?.siteId !== 'all' || filters?.uploadedBy !== 'all' || filters?.dateFrom || filters?.dateTo) && (
        <div className="flex items-center gap-2 mt-3 flex-wrap">
          <span className="text-xs text-muted-foreground">Active:</span>
          {filters?.siteId !== 'all' && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-accent/10 text-accent rounded-full text-xs font-medium">
              {sites?.find(s => s?.id === filters?.siteId)?.site_name || 'Site'}
              <button onClick={() => handleChange('siteId', 'all')}><Icon name="X" size={10} /></button>
            </span>
          )}
          {filters?.uploadedBy !== 'all' && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-accent/10 text-accent rounded-full text-xs font-medium">
              {workers?.find(w => w?.id === filters?.uploadedBy)?.full_name || 'Worker'}
              <button onClick={() => handleChange('uploadedBy', 'all')}><Icon name="X" size={10} /></button>
            </span>
          )}
          {(filters?.dateFrom || filters?.dateTo) && (
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-accent/10 text-accent rounded-full text-xs font-medium">
              {filters?.dateFrom || '...'} → {filters?.dateTo || '...'}
              <button onClick={() => { handleChange('dateFrom', ''); handleChange('dateTo', ''); }}><Icon name="X" size={10} /></button>
            </span>
          )}
          <button
            onClick={() => onChange?.({ siteId: 'all', uploadedBy: 'all', dateFrom: '', dateTo: '' })}
            className="text-xs text-muted-foreground hover:text-foreground underline"
          >
            Clear all
          </button>
        </div>
      )}
    </div>
  );
};

export default GalleryFilters;
